import {subduedTextColour} from "../../../../style/styleConsts";
import styled from "styled-components";

const TruncatedText = styled.div`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

export const AuthorName = styled(TruncatedText)`
    font-weight: bold;
    min-width: 115px;
    margin-right: 5px;
`;

export const CompanyName = styled(TruncatedText)`
    width: ${props => props.width + "px"};
    margin-right:  ${props => props.marginRight + "px"};
    color: ${props => props.isHighlighted ? "white" : subduedTextColour};
`;